import { convertColorToRGBA } from '@/utils/utils';
import { useEffect } from 'react';
import { ChatButtonContainer } from './styled';

const ChatButton = (props) => {
  // 按钮图标、按钮状态、设置按钮函数
  const { chatIconClose, chatIconOpen, toggleIcon, setToggleIcon, chatConfig, count, setMessageCount, device } = props;

  /**
   * 聊天组件图标地址
   * @returns {string|*}
   */
  const chatIconPath = () => {
    if (chatConfig.chatWindowTriggerIcon) {
      return chatConfig.chatWindowTriggerIcon;
    }
    return toggleIcon ? chatIconClose : chatIconOpen;
  };
  useEffect(() => {
    console.log(toggleIcon);
    if (!toggleIcon) {
      setMessageCount(0);
    }
  }, [toggleIcon]);
  /**
   * 处理点击Chat图标
   */
  const handleClickChatIcon = () => {
    // 切换聊天图标
    const newToggleState = !toggleIcon;
    setToggleIcon(newToggleState);
  };

  {
    return toggleIcon ? (
      <ChatButtonContainer
        style={{
          bottom:
            device === 'mobile' && chatConfig.useNewMobileChat
              ? chatConfig.mobileIconPosition?.bottom || 'auto'
              : device === 'pc'
              ? chatConfig.pcIconPosition?.bottom != 'auto'
                ? chatConfig.pcIconPosition?.bottom + 'px'
                : 'auto'
              : '30px',
          right:
            device === 'mobile' && chatConfig.useNewMobileChat
              ? chatConfig.mobileIconPosition?.right || 'auto'
              : device === 'pc'
              ? chatConfig.pcIconPosition?.right != 'auto'
                ? chatConfig.pcIconPosition?.right + 'px'
                : 'auto'
              : '50px',
          top:
            device === 'mobile' && chatConfig.useNewMobileChat
              ? chatConfig.mobileIconPosition?.top || 'auto'
              : device === 'pc'
              ? chatConfig.pcIconPosition?.top + 'px'
              : 'auto',
          left:
            device === 'mobile' && chatConfig.useNewMobileChat
              ? chatConfig.mobileIconPosition?.left || 'auto'
              : device === 'pc'
              ? chatConfig.pcIconPosition?.left != 'auto'
                ? chatConfig.pcIconPosition?.left + 'px'
                : 'auto'
              : 'auto',
          zIndex: 1000,
          background: chatConfig.chatWindowTriggerIcon
            ? 'transparent'
            : `linear-gradient(to bottom, ${convertColorToRGBA(chatConfig.chatThemeColor, '0.5')}, ${
                chatConfig.chatThemeColor
              })`,
        }}
        $chatThemeColorIn={convertColorToRGBA(chatConfig.chatThemeColor, 0.5)}
        $chatThemeColor={chatConfig.chatThemeColor}
        onClick={handleClickChatIcon}
        key={1}
      >
        {/* <img src={chatIconPath()} alt="" onClick={handleClickChatIcon} /> */}
        {count > 0 && (
          <span
            style={{
              position: 'absolute',
              top: -10,
              right: -10,
              background: '#ff4d4f',
              color: 'white',
              borderRadius: '50%',
              minWidth: '18px',
              height: '18px',
              padding: '2px 2px',
              fontSize: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {count}
          </span>
        )}
        {chatConfig.chatWindowTriggerIcon ? (
          <img src={chatConfig.chatWindowTriggerIcon} style={{ width: '100%', height: '100%' }} />
        ) : (
          <img src={chatIconPath()} style={{ width: 30, height: 30 }} />
        )}
        {/* <img src={chatIconPath()} style={{ width: 30, height: 30 }} /> */}
      </ChatButtonContainer>
    ) : (
      <ChatButtonContainer
        style={{
          bottom:
            device === 'mobile' && chatConfig.useNewMobileChat
              ? chatConfig.mobileIconPosition?.bottom || 'auto'
              : device === 'pc'
              ? chatConfig.pcIconPosition?.bottom != 'auto'
                ? chatConfig.pcIconPosition?.bottom + 'px'
                : 'auto'
              : '30px',
          right:
            device === 'mobile' && chatConfig.useNewMobileChat
              ? chatConfig.mobileIconPosition?.right || 'auto'
              : device === 'pc'
              ? chatConfig.pcIconPosition?.right != 'auto'
                ? chatConfig.pcIconPosition?.right + 'px'
                : 'auto'
              : '50px',
          top:
            device === 'mobile' && chatConfig.useNewMobileChat
              ? chatConfig.mobileIconPosition?.top || 'auto'
              : device === 'pc'
              ? chatConfig.pcIconPosition?.top != 'auto'
                ? chatConfig.pcIconPosition?.top + 'px'
                : 'auto'
              : 'auto',
          left:
            device === 'mobile' && chatConfig.useNewMobileChat
              ? chatConfig.mobileIconPosition?.left || 'auto'
              : device === 'pc'
              ? chatConfig.pcIconPosition?.left != 'auto'
                ? chatConfig.pcIconPosition?.left + 'px'
                : 'auto'
              : 'auto',
          zIndex: 1000,
          background: chatConfig.chatWindowTriggerIcon
            ? 'transparent'
            : `linear-gradient(to bottom, ${convertColorToRGBA(chatConfig.chatThemeColor, '0.5')}, ${
                chatConfig.chatThemeColor
              })`,
        }}
        $chatThemeColorIn={convertColorToRGBA(chatConfig.chatThemeColor, '0.5')}
        $chatThemeColor={chatConfig.chatThemeColor}
        onClick={handleClickChatIcon}
        key={2}
      >
        {/* <img src={chatIconPath()} alt="" onClick={handleClickChatIcon} /> */}
        {chatConfig.chatWindowTriggerIcon ? (
          <img src={chatConfig.chatWindowTriggerIcon} style={{ width: '100%', height: '100%' }} />
        ) : (
          <img src={chatIconPath()} style={{ width: 48, height: 48 }} />
        )}
        {/* <img src={chatIconPath()} style={{ width: 48, height: 48 }} /> */}
        {count > 0 && (
          <span
            style={{
              position: 'absolute',
              top: -10,
              right: -10,
              background: '#ff4d4f',
              color: 'white',
              borderRadius: '50%',
              minWidth: '18px',
              height: '18px',
              padding: '2px 2px',
              fontSize: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {count}
          </span>
        )}
      </ChatButtonContainer>
    );
  }
};

export default ChatButton;
